// LIST
export const FETCH_NETWORK = "app/NETWORK/FETCH_NETWORK";
export const FETCH_NETWORK_SUCCESS = "app/NETWORK/FETCH_NETWORK_SUCCESS";
export const FETCH_NETWORK_FAILURE = "app/NETWORK/FETCH_NETWORK_FAILURE";

// GET VIEW DATA
export const GET_VIEW_DATA = "app/NETWORK/GET_VIEW_DATA";
export const GET_VIEW_DATA_SUCCESS = "app/NETWORK/GET_VIEW_DATA_SUCCESS";
export const GET_VIEW_DATA_FAILURE = "app/NETWORK/GET_VIEW_DATA_FAILURE";

// ADD
export const ADD_NETWORK = "app/NETWORK/ADD_NETWORK";
export const ADD_NETWORK_SUCCESS = "app/NETWORK/ADD_NETWORK_SUCCESS";
export const ADD_NETWORK_FAILURE = "app/NETWORK/ADD_NETWORK_FAILURE";

// EDIT
export const EDIT_NETWORK = "app/NETWORK/EDIT_NETWORK";
export const EDIT_NETWORK_SUCCESS = "app/NETWORK/EDIT_NETWORK_SUCCESS";
export const EDIT_NETWORK_FAILURE = "app/NETWORK/EDIT_NETWORK_FAILURE";

// DELETE
export const DELETE_NETWORK = "app/NETWORK/DELETE_NETWORK";
export const DELETE_NETWORK_SUCCESS = "app/NETWORK/DELETE_NETWORK_SUCCESS";
export const DELETE_NETWORK_FAILURE = "app/NETWORK/DELETE_NETWORK_FAILURE";

export const SEARCH_NETWORK = "app/NETWORK/SEARCH_NETWORK";
export const SEARCH_NETWORK_SUCCESS = "app/NETWORK/SEARCH_NETWORK_SUCCESS";
export const SEARCH_NETWORK_FAILURE = "app/NETWORK/SEARCH_NETWORK_FAILURE";
